import { Box, Container, Typography, Paper } from '@mui/material';
import ComparisonSlider from '../../components/common/ComparisonSlider';

const SelfPortraitPageLayout = () => {
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography 
          variant="h1" 
          sx={{ 
            fontSize: { xs: '2.5rem', md: '3.5rem' },
            fontWeight: 700,
            color: '#2c3e50',
            mb: 2,
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
          }}
        >
          Self Portrait
        </Typography>
        <Typography 
          variant="subtitle1" 
          sx={{ 
            fontSize: { xs: '1.1rem', md: '1.25rem' },
            color: '#7f8c8d',
            fontFamily: 'Georgia, serif',
            mb: 2
          }}
        >
          Can you tell which is which?
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: '0.95rem', md: '1rem' },
            color: '#95a5a6',
            fontStyle: 'italic',
            maxWidth: '600px',
            mx: 'auto'
          }}
        >
          Drag the slider to compare Philip's photograph with his artistic self-portrait
        </Typography>
      </Box>
      
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, md: 4 },
          backgroundColor: 'white',
          borderRadius: 2,
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
        }}
      >
        <ComparisonSlider 
          topImage='/selfPortrait-photo.jpeg' 
          bottomImage='/selfPortrait-art.jpeg' 
        />
      </Paper>
    </Container>
  );
};

export default SelfPortraitPageLayout;
